import React from "react";
import { useState, useRef, useEffect } from "react";
import { withRouter } from "../../_shared/withRouter";
import { useTranslation } from "react-i18next";

const TermsComponent = (props) => {
  const { t } = useTranslation();
  const [footerHeight, setFooterHeight] = useState(50);
  const ref = useRef();
  useEffect(() => {
    setFooterHeight(ref.current.offsetHeight)
  })
  return (
    <div className="terms-wrapper">
      {/* <HeadingComponent text="App Terms and Condtions" /> */}
      <div className="fixed-top stripe py-3 border-bottom heading-wrapper terms-register-heading-wrapper">
        <p className="fw-bold text-center terms-page-heading text-dark mb-0">
          {t("common.terms.heading")}
        </p>
      </div>
      <div className="mx-3 text-justify terms px-3 terms-text terms-page-body" dangerouslySetInnerHTML={{ __html: t("common.terms.bodyHtml") }} />
      <div style={{ minHeight: `${footerHeight}px` }}>
        <div className="fixed-bottom stripe py-3 border-top" ref={ref}>
          <div className="col-md-12 text-center">
            {props?.roleType !== "user" && (
              <div className="btn-wrapper d-flex flex-wrap justify-content-around align-items-center">
                <button
                  className="btnFooter footer-width py-2 px-2 btn-block-xs min-width-btn-md text-dark"
                  onClick={() => props?.accept()}
                >
                  {t("common.terms.acceptAndClose")}
                </button>

                <button
                  className="footer-width btn btn-own mt-4 mt-md-0 btn-block-xs grey-btn py-2 px-2 min-height-lg min-width-btn-md"
                  onClick={() => props.history.push('/user/login')}
                >
                  {t("common.terms.cancel")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <style jsx>{`
      th {
    display: table-cell;
    vertical-align: inherit;
    font-weight: bold;
    text-align: -internal-center;
    unicode-bidi: isolate;
    text-align:center;
        border: 2px solid;
}
    .th, td {
        border-style: solid;
        text-align: center;
    }
    @media (max-width: 768px) {
        .terms-page-heading {
            text-align: left !important;
            font-size: clamp(10px, 4vw, 14px) !important;
            white-space: nowrap;
        }
    }

`}</style>
    </div>
  );
};

export default withRouter(TermsComponent);
